import BaseComponent from "@js/components/base_component.jsx";

class MuiUserRolesForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  render() {
    return (
      <div>
        <ErrorBanner entity={ this.props.entity } />

        <Panel heading="user_details">
          <div className="form-horizontal">
            <InputField
              object={ this.props.entity }
              type="mui_user_role"
              field="name"
              editing={ this.props.editing && this.props.entity.user_role_id == null }
            />
            <InputField
              object={ this.props.entity }
              type="mui_user_role"
              field="email"
              editing={ this.props.editing && this.props.entity.user_role_id == null }
            />
            {
              this.props.is_master_account ? (
                <input type="hidden" name="mui_user_role[role]" value="master" />
              ) : (
                <SelectField
                  field="mui_user_role.role"
                  blank="mui_user_role_role"
                  value={ this.props.entity.role }
                  options={ this.props.user_role_options }
                  editing={ this.props.editing }
                  onChange={ e => this.setState({ user_deliver: e.target.value }) }
                  error={ this.props.entity.errors ? this.props.entity.errors.role : null }
                />
              )
            }
          </div>
        </Panel>
      </div>
    );
  }

}

export default MuiUserRolesForm;
